module.exports = __webpack_public_path__ + "static/media/profile_pack2.58484802.png";